import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getSurveyDefaultQnsAction = createAsyncThunk(
    'get-survey-default-qns',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/get-survey-default-qns-ans`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getSurveyDefaultQnsSlice = createSlice({
    name: 'get-survey-default-qns',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getSurveyDefaultQnsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getSurveyDefaultQnsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getSurveyDefaultQnsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getSurveyDefaultQnsReducer = getSurveyDefaultQnsSlice.reducer    